module.exports = __webpack_public_path__ + "static/media/stats.1da419c3.jpg";